// extracted by mini-css-extract-plugin
export default {"bottom":"Footer_bottom__p9Eq4"};